module.exports = __webpack_public_path__ + "img/hero-tokenomics.ec2fcc77.png";